import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import './faqs.scss';
import { questionsAndAnswers } from './questions-and-answers';
import FAQList from '../../../features/common/faq/components/FAQList';
import ContactInformation from '../../../features/dealer/help/components/ContactInformation';
import { useAuth } from '../../../contexts/auth';
import { BusinessFlow } from '../../../types/enums';
import { useGetCompany } from '../../../api/company';

export default function FAQsPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Help')
	}, [pageTitle]);

	const { user } = useAuth();
	const dealer = useGetCompany(user?.companyId);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<div className='dx-card wide-card dealer-help'>

					<ContactInformation />

					{
						dealer.data?.businessFlowID === BusinessFlow.Lowes &&
						<FAQList questionsAndAnswers={questionsAndAnswers} />
					}

				</div>
			</div>
		</React.Fragment>
	)
} 
